export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/b552ae94a3baa9664c4076d726380c66.svg";